module.exports = __webpack_public_path__ + "img/login-office-dark.cb4a995f.jpeg";